type AuthInfo = {
  userId: string;
  username: string;
  role: "USER" | "MANAGER" | "ADMIN";
  expiry: Date;
};

export const useAuthStore = defineStore("auth", () => {
  const authInfo = ref<AuthInfo>();
  const lastResult = ref<LoginResult>();
  const requestFetch = useRequestFetch();

  const loginAsync = async (username: string, password: string) => {
    try {
      if (username === authInfo.value?.username) {
        return false;
      }
      if (!!authInfo.value) {
        logoutAsync();
      }
      const data = await requestFetch("/api/v1/auth/login", {
        method: "POST",
        body: {
          username,
          password,
        },
      });
      lastResult.value = "ok";
      authInfo.value = data;
      console.log(
        "[Login]",
        `Authenticated as ${authInfo.value?.role} ${authInfo.value?.username}`,
      );
      return true;
    } catch (error) {
      console.error(error);
      authInfo.value = undefined;
      if (error instanceof H3Error) {
        lastResult.value = getStatusCodeResult(error.statusCode);
      } else {
        lastResult.value = "internalError";
      }
      return false;
    }
  };

  const renewAsync = async () => {
    try {
      const data = (await requestFetch("/api/v1/auth/renew", {
        method: "GET",
        // Important to check only from client, since the sessionToken cookie would not be available
        server: false,
        credentials: "include",
      })) as AuthInfo;
      if (JSON.stringify(data) === JSON.stringify(authInfo.value)) {
        console.log(
          "[Login]",
          `Renewed login as ${authInfo.value?.role} ${authInfo.value?.username}`,
        );
        return true;
      }
      lastResult.value = "ok";
      authInfo.value = data;
      console.log(
        "[Login]",
        `Authenticated as ${authInfo.value?.role} ${authInfo.value?.username}`,
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  const logoutAsync = async () => {
    try {
      await requestFetch("/api/v1/auth/logout", {
        method: "POST",
      });
    } finally {
      authInfo.value = undefined;
    }
  };

  return {
    loginAsync,
    renewAsync,
    logoutAsync,
    authInfo,
    lastResult,
  };
});
